import type { ServerConfig } from '@/@types';

export const serverConfig: ServerConfig = {
  subject: 'bci环境',
  environment: 'bci',
  apiSrc: 'https://bci-api.pdaia.cn',
  questionarySrc: 'https://que-design-lite.pdaia.cn',
};
